import { Carrousel } from "../../Carrousel";
import HtmlRenderer from "../../HtmlRenderer";
import React from "react";
import { useLanguage } from "../../hooks/useLanguage";

const creekLabels = {
  creek: {
    da: "Vandløb",
    en: "Stream",
    de: "Flieβgewässer",
  },
  whoFishes: {
    da: "Foreninger som fisker i dette vandløb",
    en: "Associations fishing in this stream",
    de: "Verbände, die in diesem Flieβgewässer fischen",
  },
  noOne: {
    da: "Ingen foreninger er tilknyttet dette vandløb.",
    en: "No associations are associated with this stream.",
    de: "Mit diesem Flieβgewässer sind keine Assoziationen verbunden.",
  },
};

/*
 * This component displays the content of the creek sidebar
 */

export default function CreeksSidebar(props: { feature: any }) {
  const language = useLanguage();
  if (!props.feature) return null;

  const images = props.feature.properties.BILLEDER
    ? props.feature.properties.BILLEDER.split(",").map((x) => x.trim())
    : [];

  // const noOne = !(
  //   props.feature.properties.FORENING_1 ||
  //   props.feature.properties.FORENING_2 ||
  //   props.feature.properties.FORENING_3
  // );

  return (
    <div className="creekDescription">
      <h3>
        {creekLabels.creek[language]} {props.feature.properties.VANDLØB}
      </h3>
      <Carrousel images={images} />
      {/* <p style={{ margin: 0 }}>{creekLabels.whoFishes[language]}</p> */}
      {props.feature.properties.BESKRIVELSE && (
        <div>
          <HtmlRenderer html={props.feature.properties.BESKRIVELSE} />
        </div>
      )}
      {/* {noOne && <span>${creekLabels.noOne[language]}</span>} */}
      <ul>
        {props.feature.properties.FORENING_1 && (
          <a
            href={`http://${props.feature.properties.LINK_FORENING1}`}
            style={{ color: "white" }}
          >
            <li>{props.feature.properties.FORENING_1}</li>
          </a>
        )}
        {props.feature.properties.FORENING_2 && (
          <a
            href={`http://${props.feature.properties.LINK_FORENING2}`}
            style={{ color: "white" }}
          >
            <li>{props.feature.properties.FORENING_2}</li>
          </a>
        )}
        {props.feature.properties.FORENING_3 && (
          <a
            href={`http://${props.feature.properties.LINK_FORENING3}`}
            style={{ color: "white" }}
          >
            <li>{props.feature.properties.FORENING_3}</li>
          </a>
        )}
      </ul>
    </div>
  );
}
